import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalWrapper } from '../common';

export default function PasswordChangeCompleteModal({ onClose }) {
  const { t } = useTranslation();
  useEffect(() => {
    const timer = setTimeout(onClose, 2000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <ModalWrapper onClose={onClose} variant="centered">
      <h2 className="text-xl font-bold text-mono-900">{t('common.password_change_complete_title')}</h2>
      <p className="text-sm text-mono-500">{t('common.password_change_complete_desc')}</p>
    </ModalWrapper>
  );
}
